import React, { useEffect, useRef, useState, useContext } from 'react';
import styled from 'styled-components';
import MenuTemplate from './Templates/MenuTemplate';
import { OrderContext } from '../context/orderContext';
//import { foods } from "../Data/FoodData";
import Search, { createFilter } from '../Search';
import { POPULAR_SECTION_ID } from '../Hooks/useOrders';
import { corianderGreen } from '../Styles/colors';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import startNewOrder from '../Order/utils/startNewOrder';
import Button from '@material-ui/core/Button';

const MenuStyled = styled.div`
    position: relative;
    top: 40px;
    margin: 0px 100px 200px 100px;

    @media (max-width: 1000px) {
        margin: 0px 50px 200px 50px;
    }
    // Add this part
    @media (max-width: 720px) {
        width: 94%;
        margin: auto;
        margin-bottom: 200px;
        margin-top: 0px;
    }
`;

const BannerMessageDiv = styled.div`
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -0.01em;
    text-align: center;
    color: #000000;
`;

const Tagline = styled.div`
    color: #333333 100%;
    opacity: 0.5;
    font-size: 14px;
    word-spacing: 0px;
    text-align: center;
    margin-top: 10px;
    fontweight: bold;
`;

export const Notes = styled.div`
    color: #333333 100%;
    opacity: 0.5;
    font-size: 12px;
    word-spacing: 0px;
    text-align: center;
    fontweight: bold;
`;

const Hours = styled.div`
    color: #27ae60;
    font-size: 15px;
    word-spacing: 0px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 5px;
    fontweight: bold;
`;

const daysOfTheWeek = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};

const PauseMessage = styled.div`
    color: #e74c3c;
    font-size: 15px;
    word-spacing: 0px;
    text-align: center;
    margin-top: 10px;
    fontweight: bold;
`;

//Collapsible trigger={sectionName}

const CenterDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0px;
`;

const CurrentlyClosed = styled.div`
    padding: 0px 5px 0px 5px;
    background-color: #e74c3c;
    color: #ffffff;
    border-radius: 5px;
`;

const AcceptingScheduledOrder = styled.div`
    padding: 0px 5px 0px 5px;
    background-color: #27ae60;
    color: #ffffff;
    border-radius: 5px;
`;

const CancelButton = styled.div`
    margin: 0px;
    color: white;
    font-weight: bold;
    font-size: 14px;
    border-radius: 5px;
    padding: 7px;
    text-align: center;
    width: 80px;
    cursor: pointer;
    background-color: ${corianderGreen};
`;

const searchInputStyle = {
    padding: '7px',
    width: '60%',
    maxWidth: '200px',
    marginRight: '5px',
};
const SearchContainerStyle = {
    position: 'fixed',
    zIndex: 2,
    backgroundColor: 'white',
    width: '100%',
    //paddingLeft: "10px",
    paddingTop: '15px',
    paddingBottom: '10px',
};

const MenuContainerStyle = {
    position: 'relative',
    top: '60px',
};

const SearchInputContainer = styled.div`
    display: flex;
    align-content: center;
    margin: 0px 10px 0px 10px;
    padding-top: 10px;

    @media (max-width: 1000px) {
        margin: 0px 10px 0px 10px;
    }
    @media (max-width: 720px) {
        margin: 0px 10px 0px 10px;
    }
`;

export default function MenuWrapper({
    searchMobileActive,
    setSearchMobileActive,
    setOpenFood,
    menu,
    template,
    restauHours,
    areOrdersPaused,
    outsideBizHours,
    promotionMessages,
    isOrderAheadEnabled,
    disableOrdering,
}) {
    //TODO: need to get day from Timezone of the restaurant. Currently it is from the client perspective.
    var dateIndex = new Date().getDay();
    var time = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
    });
    var day = daysOfTheWeek[dateIndex];
    var nextDay = daysOfTheWeek[(dateIndex + 1) % 7];
    // Test Cases
    //day = "Monday"; nextDay= "Tuesday";

    function hoursString(hoursArray) {
        var hours = '';
        hoursArray.forEach(
            (slot) => (hours += slot.start + ' - ' + slot.end + '; ')
        );
        return hours.slice(0, -2);
    }

    function convertTo24Hour(time) {
        let [hours, minutes, period] = time
            .match(/(\d+):(\d+)\s(AM|PM)/)
            .slice(1);
        hours = parseInt(hours, 10);
        if (period === 'PM' && hours !== 12) hours += 12;
        if (period === 'AM' && hours === 12) hours = 0;
        return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }

    function getHoursStringToDisplay(curdayIndex) {
        debugger;
        let day = daysOfTheWeek[curdayIndex];
        let prevDay = daysOfTheWeek[(curdayIndex - 1 + 7) % 7];
        let nextDay = daysOfTheWeek[(curdayIndex + 1) % 7];

        let curDayHours = JSON.parse(JSON.stringify(restauHours[day] || []));
        let prevDayHours = JSON.parse(
            JSON.stringify(restauHours[prevDay] || [])
        );
        let nextDayHours = JSON.parse(
            JSON.stringify(restauHours[nextDay] || [])
        );

        //console.log(prevDayHours, curDayHours, nextDayHours);

        let formattedCurTime = convertTo24Hour(time);

        //if current day first slot start time is 00:00 (this means its extending from prev day)
        //  if the current time is within the first slot of the day
        //		if the previous day first slot start time is 00:00
        //			 scenario 1
        //			merge all prevDay's time slots (by removing first slot) and curDay's first slot
        //     else
        //			scenario 2
        //      	merge all prevDay's time slots & append curDay's first slot
        //  else
        //      if current day last slot end is 11:59 (this means its extending to next day)
        //          scenario 3
        //          merge all curDay's time slots (by removing first slot) and next day's first slot
        //      else
        //          scenario 4
        //          merge all curDay's time slots (by removing first slot)
        //else
        //  if current day last slot end is 11:59 (this means its extending to next day)
        //      scenario 5
        //      merge all curDay's time slots and next day's first slot
        //  else
        //      scenario 6
        //       merge all curDay's time slots

        //***More optimized logic, avoiding multiple if else conditions***/
        //if current day first slot start time is 00:00 (this means its extending from prev day)
        //  if the current time is within the first slot of the day
        //      day = day - 1
        //check of first slot of the day starts with 00:00, remove first slot
        //check of the last slot of the day ends with 11:59, next day first slot starts with 00:00 then merge last and first slot of next day

        let firstSlotCurrentDay =
            curDayHours.length > 0 ? curDayHours[0] : null;
        let lastSlotCurrentDay =
            curDayHours.length > 0 ? curDayHours[curDayHours.length - 1] : null;
        let firstSlotNextDay = nextDayHours.at(0); // nextDayHours.length ? nextDayHours[0] : null;
        let lastSlotPrevDay =
            prevDayHours.length > 0
                ? prevDayHours[prevDayHours.length - 1]
                : null;

        if (
            firstSlotCurrentDay &&
            firstSlotCurrentDay.start === '12:00 AM' &&
            lastSlotPrevDay &&
            lastSlotPrevDay.end === '11:59 PM'
        ) {
            if (
                formattedCurTime >=
                    convertTo24Hour(firstSlotCurrentDay.start) &&
                formattedCurTime <= convertTo24Hour(firstSlotCurrentDay.end)
            ) {
                console.log('Scenario 1');

                //if this condition matches, then its still the previous day's timings.
                //reset previousday as currentday and currentday as nextday
                nextDayHours = JSON.parse(JSON.stringify(curDayHours));
                curDayHours = JSON.parse(JSON.stringify(prevDayHours));

                //reset the currentday and nextday timings
                firstSlotCurrentDay =
                    curDayHours.length > 0 ? curDayHours[0] : null;
                lastSlotCurrentDay = curDayHours.length
                    ? curDayHours[curDayHours.length - 1]
                    : null;

                firstSlotNextDay =
                    nextDayHours.length > 0 ? nextDayHours[0] : null;
            }
        }

        //if the first slot of the current day starts at 12:00 AM, then it belongs to previous day
        // remove it from currentday hours.
        if (
            firstSlotCurrentDay &&
            firstSlotCurrentDay.start === '12:00 AM' &&
            lastSlotPrevDay &&
            lastSlotPrevDay.end === '11:59 PM'
        ) {
            console.log('Scenario 2');
            //console.log(curDayHours);
            curDayHours = curDayHours.slice(1);
        }
        //if the last slot of the current day ends at 11:59 PM and first slot of next day starts at 12:00 AM, then it extends to next day
        // merge the end time of current day with the end time of the first slot next day
        if (
            lastSlotCurrentDay &&
            lastSlotCurrentDay.end === '11:59 PM' &&
            firstSlotNextDay &&
            firstSlotNextDay.start === '12:00 AM'
        ) {
            console.log('Scenario 3');
            //console.log(curDayHours, firstSlotNextDay);
            curDayHours[curDayHours.length - 1].end = firstSlotNextDay.end;
        }

        //console.log(curDayHours);
        return curDayHours
            .map((slot) => `${slot.start} - ${slot.end}`)
            .join(', ');
    }

    const matcheMobilesMediaQuery = useMediaQuery('(max-width: 720px)');
    const [searchTerm, setSearchTerm] = useState(''); //to track search in progress and hide banner

    const [filteredMenu, setFilteredMenu] = useState(menu);
    useEffect(() => {
        let tempMenu = menu;
        if (searchTerm && searchTerm.trim().length > 0 && menu) {
            const filtersFoods = menu
                .filter((sec) => sec.id != POPULAR_SECTION_ID)
                .flatMap((sec) => sec.foods)
                .filter(
                    createFilter(searchTerm, ['name', 'desc'], {
                        fuzzy: false,
                    })
                );
            tempMenu = [
                {
                    id: 'searchResult' + searchTerm,
                    name: 'Results for ' + searchTerm,
                    foods: filtersFoods,
                },
            ];
        }
        setFilteredMenu(tempMenu);
    }, [menu, searchTerm]);

    const searchRef = useRef(null);
    // if(searchRef && searchTerm && searchTerm.length > 0) {
    //   searchRef.current
    //     && searchRef.current.inputRef
    //     && searchRef.current.inputRef.current
    //     && searchRef.current.inputRef.current.focus();
    // }
    const showCountInResults =
        searchTerm && searchTerm.length > 0 ? { showCount: true } : {};

    const searchInputRef = useRef();
    const containerMenuRef = useRef();
    //const searchMobileActive = (matcheMobilesMediaQuery && document.activeElement === searchInputRef.current);

    const context = useContext(OrderContext);

    return (
        <MenuStyled ref={containerMenuRef}>
            {!searchMobileActive && (
                <>
                    <Tagline>Same prices. More convenience.</Tagline>
                    {promotionMessages && promotionMessages.banner_message && (
                        <BannerMessageDiv style={{ color: 'green' }}>
                            {promotionMessages.banner_message
                                .split('\n')
                                .map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                        </BannerMessageDiv>
                    )}

                    {day in restauHours ? (
                        <Hours>
                            {' '}
                            <i className="fas fa-clock"></i>
                            {restauHours[day].length > 0
                                ? ' Open today: ' +
                                  getHoursStringToDisplay(dateIndex)
                                : ' Closed ' + day}{' '}
                        </Hours>
                    ) : (
                        // Assumes restaurants are not closed on consecutive days
                        <>
                            {nextDay in restauHours &&
                            restauHours[nextDay].length > 0 ? (
                                <Hours>
                                    {' '}
                                    <i className="fas fa-clock"></i> Open
                                    tomorrow:{' '}
                                    {getHoursStringToDisplay(dateIndex + 1)}
                                </Hours>
                            ) : (
                                <></>
                            )}
                        </>
                    )}
                    {areOrdersPaused ? (
                        <PauseMessage>
                            {' '}
                            We are not taking new orders at this time. Please
                            try again later.{' '}
                        </PauseMessage>
                    ) : (
                        <></>
                    )}
                    {outsideBizHours && !areOrdersPaused ? (
                        <>
                            <CenterDiv>
                                <CurrentlyClosed>
                                    Currently closed
                                </CurrentlyClosed>
                            </CenterDiv>
                            {isOrderAheadEnabled ? (
                                <CenterDiv>
                                    <AcceptingScheduledOrder>
                                        Accepting Future Orders
                                    </AcceptingScheduledOrder>
                                </CenterDiv>
                            ) : (
                                // <Notes>
                                //     {' '}
                                //     Currently Closed but Accepting Future Orders{' '}
                                // </Notes>
                                <Notes>
                                    {' '}
                                    Orders placed now can only be processed when
                                    the store opens again{' '}
                                </Notes>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                    {disableOrdering && (
                        <div style={{ textAlign: 'center' }}>
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    startNewOrder(context, null);
                                }}
                            >
                                Start New Order
                            </Button>
                        </div>
                    )}
                </>
            )}
            {
                <div
                    style={searchMobileActive ? SearchContainerStyle : null}
                    ref={searchInputRef}
                >
                    <SearchInputContainer>
                        <Search
                            type={'input'}
                            onFocus={() => {
                                if (!matcheMobilesMediaQuery) return;
                                const { offsetTop } = searchInputRef.current;
                                containerMenuRef.current.scrollTop = offsetTop;
                                setSearchMobileActive(true);
                            }}
                            ref={searchRef}
                            style={searchInputStyle}
                            value={searchTerm}
                            onChange={(term) => {
                                setSearchTerm(term);
                            }}
                        ></Search>
                        {searchMobileActive && (
                            <CancelButton
                                onClick={() => {
                                    setSearchTerm('');
                                    setSearchMobileActive(false);
                                }}
                            >
                                Cancel
                            </CancelButton>
                        )}
                    </SearchInputContainer>
                </div>
            }
            <div style={searchMobileActive ? MenuContainerStyle : null}>
                <MenuTemplate
                    menu={filteredMenu}
                    setOpenFood={setOpenFood}
                    template={template}
                    {...showCountInResults}
                />
            </div>
        </MenuStyled>
    );
}
